import { customReduxEvents, getReduxEvent } from './reduxStatisticsEvents';

/**
 * Checks if the specific action has a corresponding custom redux event defined.
 * @param {*} action
 * @returns {boolean}
 */
const existsInCustomReduxEvents = action => {
  return Object.keys(customReduxEvents).includes(action.type);
};
/**

 * This object has all the properties that we are interested in "catching" in relation to our redux events, in order to report them.
 * @param {*} object
 * @param {*} state
 * @returns {object}
 */
const buildPayload = object => {
  if (!object) return;
  return {
    enableMountingRails: !object?.disableMountingRails,
    view: object?.view,
    dialogType: object?.dialogType,
    filter: object?.filter,
    item: object?.item?.id,
    parent: object?.parent?.id,
    connectsTo: object?.item?.connectsTo?.id,
    extended: object?.extended,
    origin: object?.origin,
    optionValue: object?.optionValue,
    optionType: object?.optionType,
    width: object?.width,
    height: object?.height,
    subFilterDepth: object?.subFilter,
    subFilterColor: object?.colorFilter?.name,
    nonInteraction: object?.nonInteraction,
    xPosition: object?.item?.x,
    yPosition: object?.item?.y,
    zPosition: object?.item?.z,
  };
};

/**
 * Checks if the action has a corresponding custom redux events or if we have
 * specified in the meta-data that a specific action should not be reported.
 * @param {*} action
 * @returns {boolean}
 */
const shouldNotBeReported = action => {
  return (
    !action ||
    action.meta?.shouldReport === false ||
    !existsInCustomReduxEvents(action)
  );
};

/**
 * This function executes as part of the redux middleware.
 * Every action dispatched in the codebase enters this function.
 * @param {*} action
 * @param {*} state
 * @returns {undefined}
 */
export function reduxEventReporter(action) {
  if (shouldNotBeReported(action)) return;
  const event = getReduxEvent(action.type);
  event.reportEvent(
    action.type,
    buildPayload(action.payload),
    buildPayload(action.meta)
  );
}
